import Block from "Components/UI/Block/Block";
import React, { useEffect } from "react";
import styles from "./RecentComments.module.scss";
import {
  selectDashboardRecentComments,
  selectDashboardRecentCommentsLoading,
} from "Redux/Dashboard/slice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "Redux/store";
import { getDashboardRecentComments } from "Redux/Dashboard/reducer";
import { FORMAT_MONTH_DATE_YEAR } from "Shared/Constants/app";
import { format } from "Shared/Utils/shared";
import Link from "Components/UI/Link/Link";
import {
  GET_UNIT_DETAIL_PATH,
  USER,
  WORK_ORDERS,
  PART,
  ISSUE,
  FUEL_HISTORY,
  REMINDERS_SERVICES,
} from "Shared/Constants/routes";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";

const getRedirectPath = (objectType: string, objectId: string) => {
  switch (objectType) {
    case "contact":
      return `${USER}/${objectId}`;
    case "issue":
      return `${ISSUE}/${objectId}`;
    case "work_order":
      return `${WORK_ORDERS}/${objectId}`;
    case "part":
      return `${PART}/${objectId}`;
    case "service_reminder":
      return `${REMINDERS_SERVICES}/${objectId}`;
    case "fuel_entry":
      return `${FUEL_HISTORY}/${objectId}`;
    case "vehicle":
      return GET_UNIT_DETAIL_PATH(objectId);
    default:
      return "#";
  }
};

const RecentComments: React.FC = () => {
  const dispatch = useAppDispatch();
  const recent = useSelector(selectDashboardRecentComments);
  const loading = useSelector(selectDashboardRecentCommentsLoading);

  useEffect(() => {
    dispatch(getDashboardRecentComments());
  }, [dispatch]);

  if (loading) return <SkeletonLoader />;

  return (
    <Block className={styles.block}>
      <h3>Recent Comments</h3>
      <div>
        {recent.length > 0 ? (
          recent.map((el) => (
            <div key={el.id} className={styles.comments__item}>
              <div className={styles.comments__item__container}>
                <div className={styles.comments__item__container__avatar} />
                <div className={styles.comments__item__container__text}>
                  <span>{el.created_by?.first_name}</span> commented on
                  <span>
                    {el.object_type}
                    <Link to={getRedirectPath(el.object_type, el.object_id)}>
                      ({el.object_name})
                    </Link>
                  </span>
                </div>
              </div>
              <div className={styles.comments__item__time}>
                {format(el.created, FORMAT_MONTH_DATE_YEAR)}
              </div>
            </div>
          ))
        ) : (
          <h4>Not found comments</h4>
        )}
      </div>
    </Block>
  );
};

export default RecentComments;
